import React from "react";
import InvoiceContainer from "./invoice/InvoiceContainer";
import EditPreliquidationAmountContainer from "./editPreliquidationAmount/EditPreliquidationAmountContainer";
import "./wrapperPreliquidation.scss";

import DetailPreliquidationContainer from "./preliquidation/DetailPreliquidationContainer";
import {
  PagesPreliquidationTypes,
  WrapperPreliquidationPropsType,
} from "./types";
import RejectInvoiceContainer from "./rejectInvoice/RejectInvoiceContainer";
import { TabType } from "component/TabControler/types";

import { Paginator } from "@pickit/pickit-components";
import { ReactComponent as Presettlement } from "assets/calcBlack.svg";
import { ReactComponent as Invoice } from "assets/invoiceBlack.svg";

const tabs: TabType<PagesPreliquidationTypes>[] = [
  {
    title: "detailPresettlement:presettlement",
    id: "preliquidation",
    testId: "detail-preliquidations-tab-presettlement",
    icon: Presettlement,
    name: "presettlement",
  },
  {
    title: "detailPresettlement:invoice",
    testId: "detail-preliquidations-tab-invoice",
    id: "invoice",
    icon: Invoice,
    name: "invoice",
  },
];

export const WrapperPreliquidation: React.FC<
  WrapperPreliquidationPropsType
> = ({
  actualPage,
  showModal,
  currentInvoice,
  invoicesIds,
  isBulkFlow,
  onPageClick,
}): JSX.Element => {
  return (
    <>
      {actualPage === "preliquidation" ? (
        <DetailPreliquidationContainer
          tabs={tabs}
          testId="detail-preliquidation"
        />
      ) : (
        <InvoiceContainer tabs={tabs} />
      )}
      {isBulkFlow && (
        <div className="paginator-container">
          <Paginator
            currentPage={currentInvoice}
            totalPages={invoicesIds?.length}
            onPageClick={onPageClick}
          />
        </div>
      )}
      <EditPreliquidationAmountContainer />
      <RejectInvoiceContainer isOpen={showModal} />
    </>
  );
};
